import styled from 'styled-components'

export const H1 = styled.h1`
  text-align: center;
`
